import { PictureCategoryItem } from "../objects/pictureCategoryItem";
import { PictureCategoryListCriteria } from "../objects/pictureCategoryList";

export const EMPTY_PICTURE_CATEGORY: PictureCategoryItem = {
    name: '',
    localization: []
};

export const EMPTY_PICTURE_CATEGORY_LIST_CRITERIA: PictureCategoryListCriteria = {
    search: '',
    page: 0,
    limit: 50
};
